import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class AppStateEffects {
  public constructor(
    public readonly actions$: Actions,
  ) {
  }
}
